import React from 'react';

import {RoleDescription, RoleIcon, RoleItem, RoleName} from './CommonRoles';

export const PredefinedRoles: React.FC = () => {
  return (
    <div className="rounded border border-moon-250">
      <div className="rounded border-b border-moon-250 bg-white px-16 py-12">
        <div className="text-base font-semibold">Predefined roles</div>
        <div className="text-sm text-moon-500">
          You can set the base role for this organization from one of these
          roles.
        </div>
      </div>
      <div className="border-b border-moon-250 px-16 py-12">
        <RoleItem>
          <RoleIcon name="book-dictionary" />
          <div className="flex-grow text-left">
            <RoleName>Viewer</RoleName>
            <RoleDescription>
              View-Only members can view assets within the team such as runs,
              reports, and workspaces. They can follow and comment on reports,
              but they can not create, edit, or delete project overview,
              reports, or runs.
            </RoleDescription>
          </div>
        </RoleItem>
      </div>
      <div className="border-b border-moon-250 px-16 py-12">
        <RoleItem>
          <RoleIcon name="pencil-edit" />
          <div className="flex-grow text-left">
            <RoleName>Member</RoleName>
            <RoleDescription>
              A regular member of the team. A team member is invited by email by
              the team admin. A team member cannot invite other members. Team
              members can only delete runs and sweep runs created by that
              member.
            </RoleDescription>
          </div>
        </RoleItem>
      </div>
      <div className="px-16 py-12">
        <RoleItem>
          <RoleIcon name="key-admin" />
          <div className="flex-grow text-left">
            <RoleName>Admin</RoleName>
            <RoleDescription>
              Team admins can add and remove other admins or team members. They
              have permissions to modify all projects and full deletion
              permissions.
            </RoleDescription>
          </div>
        </RoleItem>
      </div>
    </div>
  );
};
